import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Helper estándar de shadcn/ReUI: combina clases condicionales (clsx) y
// resuelve conflictos de utilidades Tailwind (twMerge, ej. "px-2 px-4" -> "px-4").
// Lo requieren todos los componentes vendorizados del registry @reui.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
